import React, { useState } from "react";

import { FRONT_URL } from "lib/config";
import { lessonPath } from "lib/paths";
import { youtubeThumb } from "lib/youtube";
import Button from "components/ui/Button";

function PlayIcon() {
  return (
    <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
      <path d="M5 3.8c0-1 1.1-1.6 1.9-1.1l9.6 6.2c.8.5.8 1.7 0 2.2l-9.6 6.2c-.8.5-1.9-.1-1.9-1.1z" fill="currentColor" />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">
      <circle cx="10" cy="10" r="8.3" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10 9v5M10 6.2v.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

// One joined class: thumbnail, title, progress bar and Start/Continue.
export default function ClassCard({ item }) {
  const course = item.course ?? {};
  const [broken, setBroken] = useState(false);
  const thumb = youtubeThumb(course.thumbnail);
  const progress = item.progress ?? {};
  const percent = Math.round(progress.percent ?? 0);
  const started = !!progress.last_viewed_at || percent > 0;
  const label = percent >= 100 ? "Review class" : started ? "Continue class" : "Start class";

  return (
    <div className="yc-classes-card">
      <div className="yc-classes-card-thumb">
        {thumb && !broken ? <img src={thumb} alt="" onError={() => setBroken(true)} /> : <span className="yc-classes-card-thumb-empty" aria-hidden="true">📘</span>}
        <a className="yc-classes-card-info" href={`${FRONT_URL}/courses/${course.id}`}>
          <InfoIcon />
          View info
        </a>
      </div>
      <h3 className="yc-classes-card-title">{course.name}</h3>
      <div className="yc-classes-card-progress">
        <div className="yc-classes-card-progress-row">
          <span>Progress</span>
          <span>
            <span className="yc-classes-muted">{percent}%</span> of 100%
          </span>
        </div>
        <div className="yc-classes-bar" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
          <span style={{ width: `${Math.max(percent, 2)}%` }}></span>
        </div>
      </div>
      <Button to={lessonPath(course.id, progress.resume)} size="lg" block className="yc-classes-card-action">
        <PlayIcon />
        {label}
      </Button>
    </div>
  );
}
